import clsx from 'clsx'

export interface NotificationBadgeProps {
	position: 'over' | 'near' // over: top right corner, near: near the text
	color: 'primary' | 'secondary'
	children: number
}

export const NotificationBadge = (props: NotificationBadgeProps) => {
	return (
		<span
			className={clsx('flex items-center justify-center rounded text-sm px-1 font-bold text-white', {
				'absolute top-0 right-0 translate-x-2/3 -translate-y-1/2': props.position === 'over',
				'bg-primary': props.color === 'primary',
				'bg-[#6c757d]': props.color === 'secondary',
			})}
		>
			{props.children}
		</span>
	)
}
